import { MSBBStore } from 'components/main-page/msbb-store/MSBBStore'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
    constructOptionsSelect,
    constructSelectedValue,
    convertErrorMessage,
    getAllQueryParams,
    setQueryParams,
    uploadFileToS3,
} from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/main-page/configTableMSBBStore'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { useValidation } from 'hooks/useValidation'
import { API_STORE } from 'services/apiMSBBStore'
import { BANNER_VALIDATION, STORE_VALIDATION } from 'services/validation/msbbStoreValidation'
import { Alert } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import { INIT_BANNER, INIT_STATE, FIELD_NAME_DETAIL } from 'configs/main-page/configFormMSBBStore'

export const MSBBStoreContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [storeDetail, setStoreDetail] = useState({})
    const [bannerDetail, setBannerDetail] = useState(INIT_BANNER)
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [cityOptions, setCityOptions] = useState([])
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const { fetching: getStoreList, data: storeList, isLoading } = useFetch(API_STORE.LIST)
    const { fetching: deleteStore, isLoading: isDeleting } = useFetch(API_STORE.DELETE)
    const { fetching: getCityList } = useFetch(API_STORE.CITY_LIST)
    const { fetching: createStore, isLoading: isCreating } = useFetch(API_STORE.CREATE)
    const { fetching: updateStore, isLoading: isUpdating } = useFetch(API_STORE.UPDATE)
    const { fetching: getUrlStoreBanner } = useFetch(API_STORE.URL_BANNER)
    const { fetching: getStoreBannerDetail, isLoading: isLoadingBanner } = useFetch(API_STORE.DETAIL_BANNER)
    const { fetching: updateStoreBanner, isLoading: isUpdatingBanner } = useFetch(API_STORE.UPDATE_BANNER)
    const [errorMessage, setErrorMessage] = useState({})
    const {
        validateForm: validateBanner,
        errorForm: errorBanner,
        clearErrorForm: clearErrorBanner,
    } = useValidation({
        form: bannerDetail,
        schema: BANNER_VALIDATION,
    })
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: storeDetail,
        schema: STORE_VALIDATION,
    })
    const [modal, setModal] = useState({
        delete: false,
        form: false,
        banner: false,
    })

    useEffect(() => {
        fetchStoreList()
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = queryParams.hasOwnProperty('search')
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchStoreList = (item = { ...query }) => {
        getStoreList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onActionRow = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setStoreDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                const constructItem = {
                    ...item,
                    city_id: constructSelectedValue(item?.city, 'name', 'id'),
                    phone_number: item?.phone_number?.replace(/^62/, ''),
                    opening_time: item?.opening_time?.slice(0, 5),
                    closing_time: item?.closing_time?.slice(0, 5),
                }
                const { city, ...newItem } = constructItem
                setStoreDetail(newItem)
                setShowModal({ form: true })
                break
            default:
                setShowModal({ delete: true })
        }
    }

    const onHideForm = (modal = 'form') => {
        setShowModal({ [modal]: false })
        setErrorMessage({})
        modal === 'banner' ? clearErrorBanner() : clearErrorForm()
    }

    const onSearchCity = (value = '') => {
        getCityList({ search: value }).then((response) => {
            const options = constructOptionsSelect(response?.data, 'name', 'id')
            setCityOptions(options)
        })
    }

    const onChangeForm = (e, type = 'form') => {
        const { name, value } = e
        const newItem = { [name]: value }
        if (type === 'banner') {
            setBannerDetail({ ...bannerDetail, ...newItem })
        } else {
            setStoreDetail({ ...storeDetail, ...newItem })
        }
    }

    const onDelete = () => {
        deleteStore({ ids: selectedIds }).then(() => {
            setIsResetSelectedItem(!isResetSelectedItem)
            setShowAlert('Store Deleted !', { delete: false })
            if (storeList?.data?.stores?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchStoreList()
            }
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const constructStoreDetail = {
                ...storeDetail,
                city_id: storeDetail?.city_id?.value,
                phone_number: storeDetail?.phone_number ? `62${storeDetail?.phone_number}` : null,
            }
            const { id, ...payload } = constructStoreDetail
            if (!id) {
                createStore(payload)
                    .then(() => {
                        setShowAlert('Store Created !', { form: false })
                        fetchStoreList()
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            } else {
                updateStore(payload, id)
                    .then(() => {
                        setShowAlert('Store Updated !', { form: false })
                        fetchStoreList()
                    })
                    .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
            }
        })
    }

    const setUploadBanners = async (filesName, uploadDetail) => {
        const newBanners = { ...bannerDetail }

        try {
            const s3Urls = await getUrlStoreBanner({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newBanners[uploadDetail[i]?.key] = `${item?.url}${item?.fields?.key}`
            })
            await Promise.all(apiS3list)
            onSave(newBanners)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmitBanner = () => {
        setErrorMessage({})
        validateBanner().then(async () => {
            const banners = [bannerDetail?.desktop_image_url, bannerDetail?.mobile_image_url]
            const uploadDetail = []
            const filesName = []

            banners.map((item, index) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({
                        file: item?.file,
                        key: index === 0 ? 'desktop_image_url' : 'mobile_image_url',
                    })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBanners(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...bannerDetail }) => {
        updateStoreBanner({ banner: payload })
            .then(() => setShowAlert('Banner Updated !', { banner: false }))
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        if (modal?.form) onSearchCity()
        if (modal?.banner) getStoreBannerDetail().then((response) => setBannerDetail(response?.data))
    }, [modal?.form, modal?.banner])

    const props = {
        dataList: storeList?.data,
        storeDetail,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        selectedIds,
        onSubmit,
        onDelete,
        onSelectItemHandler,
        onActionRow,
        onHideForm,
        onChangeForm,
        onSearchCity,
        cityOptions,
        bannerDetail,
        onSubmitBanner,
        errorForm: { ...errorForm, ...errorBanner, ...errorMessage },
        isLoading,
        isLoadingBanner,
        isDeleting,
        isCreating,
        isUpdating,
        isUpdatingBanner: isLoadingUpload || isUpdatingBanner,
        isResetSelectedItem,
    }

    return <MSBBStore {...props} />
}
